import React from "react";

import SelectDropdownFormik from "../selectDropdown/SelectDropdownFormik";
import {
  PRODUCT_TYPES_ENUMS,
  TCG_PLAYER_API_GRADE_ENUMS,
} from "../../../system/globalEnums";
import {
  getTradingCardConditionListForSelectedGrade,
  handleCreateSelectOptions,
  handleOnchangeTradingCardCondition,
  isTcgPlayerApi,
} from "../../utility";
import { EMPTY_STRING } from "../../../constants";

const SelectGrade = (props) => {
  const {
    isFormik = true, //true in single item modal and false in batch modal
    value,
    setFieldValue,
    label = EMPTY_STRING,
    priceChartingProductInfo,
    setIsFirstRender = () => {},
    setPriceChartingProductInfo,
    setPriceChartingProductInfoComponent = () => {},
    conditionComponent: {
      productCondition,
      setConditionList,
      setProductCondition,
    } = {},
  } = props;
  const isBatchModal = !isFormik;
  const productMetaData = isFormik
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;

  const handleGradeChange = (...props) => {
    setFieldValue(...props);
    let updatedConditionList = getTradingCardConditionListForSelectedGrade(
      props[1],
      productMetaData.subcategory
    );

    let updatedPriceChartingProductInfo = handleOnchangeTradingCardCondition(
      updatedConditionList[0],
      {
        ...priceChartingProductInfo,
        productMetaData: {
          ...priceChartingProductInfo.productMetaData,
          conditionList: updatedConditionList,
          productConditionList: updatedConditionList,
          grade: props[1],
        },
      }
    );

    setConditionList(updatedConditionList);
    setProductCondition(updatedConditionList[0]);
    setPriceChartingProductInfo({ ...updatedPriceChartingProductInfo });
    setPriceChartingProductInfoComponent({
      ...updatedPriceChartingProductInfo.productMetaData,
    });
    setIsFirstRender(false);
  };

  return (
    isTcgPlayerApi(productMetaData) && (
      <>
        {label && <label className="field-label">{label}</label>}
        <SelectDropdownFormik
          name="grade"
          className={isBatchModal ? "w-100" : EMPTY_STRING}
          wrapperClassname={
            isBatchModal ? "category-dropdowns-batch-modal" : EMPTY_STRING
          }
          value={value}
          disabled={isBatchModal ? productMetaData?.isItemLocked : false}
          setFieldValue={isBatchModal ? setFieldValue : handleGradeChange}
          options={
            productMetaData?.gradeList ??
            handleCreateSelectOptions(Object.values(TCG_PLAYER_API_GRADE_ENUMS))
          }
        />
      </>
    )
  );
};

export default SelectGrade;
